/** Eventos GTM tipados — contenedor GTM-PDG79QH. */

type DataLayerEvent =
  | { event: 'section_view'; section_name: string; section_index: number }
  | { event: 'scroll_depth'; percent: 25 | 50 | 75 | 100 }
  | { event: 'cta_click'; cta_location: string }
  | { event: 'whatsapp_click'; cta_location: string }
  | { event: 'calcom_booking' }
  | { event: 'form_submit'; form_id: string }
  | { event: 'lead_cotizacion_enviado'; source: string; origen: string; project: string; email: string; gclid: string | null }
  | { event: 'experience_quality_tier'; tier: string }
  | { event: '3d_loaded'; load_ms: number }
  | { event: 'playground_open' }
  | { event: 'playground_adjust'; control: string }
  | { event: 'theme_change'; theme: string }
  | { event: 'cal_modal_open' }

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

export function track(payload: DataLayerEvent): void {
  window.dataLayer ??= []
  window.dataLayer.push(payload)
  if (import.meta.env.DEV) console.debug('[dataLayer]', payload)
}
